import { guardClient } from '../_axios'

/**
 * タスク更新
 * [put]/tasks/{id}
 */
export type UpdateTaskRequest = {
  id: string
  columnId: string
  companyId?: number
  title: string
  description?: string
  dueDate?: string
  creator: string
  isSecret: boolean
  updatedBy: string
}

export const updateTask = async (request: UpdateTaskRequest) => {
  const { id, ...params } = request
  const path = '/tasks'
  const response = await guardClient.put(path + '/' + id, params)
  return response.data
}
